import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { globalStyles, colors } from './sharedStyles';
import Header from './components/Header';
import Hero from './components/Hero';
import Presentation from './components/Presentation';
import Services from './components/Services';
import Expertise from './components/Expertise';
import Contact from './components/Contact';
import Footer from './components/Footer';

gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    // Animations Fade In Up
    const fadeElements = document.querySelectorAll('.fade-in-up');
    fadeElements.forEach((element) => {
      gsap.to(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 85%', // Triggers slightly earlier
          toggleActions: 'play none none none',
        },
        duration: 0.6, // Slightly faster animation
        opacity: 1,
        y: 0,
        ease: 'power3.out',
        // Removed global index-based delay to prevent long waits at bottom of page
      });
    });
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const headerHeight = document.querySelector('header')?.offsetHeight || 0;
      const offsetTop = section.offsetTop - headerHeight - 20;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div style={{ backgroundColor: colors.white, color: colors.text, fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' }}>
      <style>{globalStyles}</style>

      <Header scrollToSection={scrollToSection} />
      <Hero scrollToSection={scrollToSection} />
      <Presentation scrollToSection={scrollToSection} />
      <Services scrollToSection={scrollToSection} />
      <Expertise />
      <Contact />
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}

export default App;
